/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlOnboardingActionItems } from './ControlOnboardingActionItems';
import {
    ControlOnboardingActionItemsFromJSON,
    ControlOnboardingActionItemsFromJSONTyped,
    ControlOnboardingActionItemsToJSON,
} from './ControlOnboardingActionItems';

/**
 * 
 * @export
 * @interface ControlVerifyOnboardingActionItemsRequest
 */
export interface ControlVerifyOnboardingActionItemsRequest {
    /**
     * 
     * @type {Array<ControlOnboardingActionItems>}
     * @memberof ControlVerifyOnboardingActionItemsRequest
     */
    onboarding_action_items?: Array<ControlOnboardingActionItems>;
}

/**
 * Check if a given object implements the ControlVerifyOnboardingActionItemsRequest interface.
 */
export function instanceOfControlVerifyOnboardingActionItemsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlVerifyOnboardingActionItemsRequestFromJSON(json: any): ControlVerifyOnboardingActionItemsRequest {
    return ControlVerifyOnboardingActionItemsRequestFromJSONTyped(json, false);
}

export function ControlVerifyOnboardingActionItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlVerifyOnboardingActionItemsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'onboarding_action_items': !exists(json, 'onboarding_action_items') ? undefined : ((json['onboarding_action_items'] as Array<any>).map(ControlOnboardingActionItemsFromJSON)),
    };
}

export function ControlVerifyOnboardingActionItemsRequestToJSON(value?: ControlVerifyOnboardingActionItemsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'onboarding_action_items': value.onboarding_action_items === undefined ? undefined : ((value.onboarding_action_items as Array<any>).map(ControlOnboardingActionItemsToJSON)),
    };
}

